import React from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import PrimaryButton from '../StyledComponents/PrimaryButton';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import {Close} from '@mui/icons-material';
import {theme} from '../../Theme';
import SecondaryButton from '../StyledComponents/SecondaryButton';
import BidmiiLinearProgress from '../../modules/BidmiiCustomLoader/BidmiiLinearProgress';

interface IProps {
  open: boolean;
  loading?: boolean;
  deletion?: boolean;
  title: any;
  body?: string;
  close?: string;
  confirm: string;
  onClose?: (any?: any) => void;
  onConfirm: (any: any) => void;
  onCancel?: () => void;
}

// Dialog for when user needs to confirm a permanent action
export default function AlertDialog(props: IProps) {
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={(event, reason) =>
          reason !== 'backdropClick' && props.onClose && props.onClose()
        }
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{style: {borderRadius: 10, marginLeft: 4, marginRight: 4}}}>
        {props.loading ? (
          <BidmiiLinearProgress />
        ) : (
          <div
            style={{height: 5, backgroundColor: theme.palette.secondary.main}}
          />
        )}
        {props.onCancel && (
          <IconButton
            onClick={props.onCancel}
            style={{position: 'absolute', padding: 8, right: 0}}
            size="large">
            <Close style={{fontSize: 24}} />
          </IconButton>
        )}
        <Box style={{maxWidth: 400}}>
          <Box id="alert-dialog-title" style={{padding: '24px 24px 8px'}}>
            <Typography
              variant="body1"
              gutterBottom
              style={{fontSize: 22, lineHeight: 1.3}}>
              {props.title}
            </Typography>
          </Box>
          <DialogContent>
            {props.body && (
              <Typography
                variant="subtitle1"
                style={{
                  color: theme.palette.primary.light,
                  lineHeight: 1.3,
                  whiteSpace: 'pre-line',
                }}>
                {props.body}
              </Typography>
            )}
          </DialogContent>
          <DialogActions style={{padding: '8px 24px 16px'}}>
            <Grid container justifyContent="space-between">
              <Grid item>
                {props.close && (
                  <SecondaryButton size="small" onClick={props.onClose}>
                    {props.close}
                  </SecondaryButton>
                )}
              </Grid>
              <PrimaryButton
                size="small"
                onClick={props.onConfirm}
                color={
                  props.deletion
                    ? theme.palette.red.main
                    : theme.palette.blue.main
                }>
                {props.confirm}
              </PrimaryButton>
            </Grid>
          </DialogActions>
        </Box>
      </Dialog>
    </div>
  );
}
